import { FormattedMessage, FormattedNumber } from 'react-intl';

export const ProgressBar = ({
  notional,
  executedAmount,
  color,
  isFinal,
}: {
  notional: number | null;
  executedAmount: number | null;
  color: string;
  isFinal?: boolean;
}) => {
  const progress = executedAmount !== null && notional !== null ? (executedAmount / notional) * 100 : 0;

  return (
    <div>
      <div className="d-flex justify-content-between w-100 fs-12">
        <div className="text-truncate">
          {Number.isNaN(progress) ? 0 : progress.toFixed(2)}%
          <FormattedMessage id={isFinal ? 'order.summary.filled' : 'order.summary.beingFilled'} />
        </div>
        <div className="ms-1 text-secondary">
          <FormattedNumber
            value={executedAmount ?? 0}
            minimumFractionDigits={1}
            maximumFractionDigits={1}
            notation={'compact'}
          />
        </div>
      </div>
      <div className="progress progress-sm mb-2">
        <div
          className={`progress-bar bg-${color}`}
          role="progressbar"
          aria-valuenow={executedAmount ?? 0}
          aria-valuemin={0}
          aria-valuemax={notional ?? 0}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
